<template>
  <div class="view-box">
    <div class="view-content">
      <div style="margin-bottom: 10px">{{ $t("edit.angle.angleRange") }}</div>
      <a-slider :max="currentAngle.fovrange.max" :min="currentAngle.fovrange.min" id
        v-model="currentAngle.fovrange.default" />
      <a-input-number v-model="currentAngle.fovrange.default" :max="currentAngle.fovrange.max"
        :min="currentAngle.fovrange.min" :step="1" style="width: 70px" />
      <div style="line-height: 2; text-align: center; width: 70px">
        {{ $t("edit.angle.default") }}
      </div>
      <a-slider :max="fovrangeMax" :min="fovrangeMin" range
        :value="[currentAngle.fovrange.min, currentAngle.fovrange.max]" @change="handleChangeFovrangeSlide"/>
      <div style="display: flex; justify-content: space-between">
        <div>
          <a-input-number v-model="currentAngle.fovrange.min" :max="fovrangeMax" :min="fovrangeMin" :step="1"
            style="width: 70px" />
          <div style="line-height: 2; text-align: center; width: 70px">
            {{ $t("edit.angle.fovrangeMin") }}
          </div>
        </div>
        <div>
          <a-input-number v-model="currentAngle.fovrange.max" :max="fovrangeMax" :min="fovrangeMin" :step="1"
            style="width: 70px" />
          <div style="line-height: 2; text-align: center; width: 70px">
            {{ $t("edit.angle.fovrangeMax") }}
          </div>
        </div>
      </div>

      <div style="margin: 20px 0 10px 0">{{ $t("edit.angle.vview") }}</div>
      <a-slider :max="vviewMax" :min="vviewMin" range :value="[
        this.currentAngle.viewrange.vview.min,
        this.currentAngle.viewrange.vview.max,
      ]" @change="handleChangeVviewSlide" />
      <div style="display: flex; justify-content: space-between">
        <div>
          <a-input-number v-model="currentAngle.viewrange.vview.min" :max="vviewMax" :min="vviewMin" :step="1"
            style="width: 70px" />
          <div style="line-height: 2; text-align: center; width: 70px">
            {{ $t("edit.angle.vviewMin") }}
          </div>
        </div>
        <div>
          <a-input-number v-model="currentAngle.viewrange.vview.max" :max="vviewMax" :min="vviewMin" :step="1"
            style="width: 70px" />
          <div style="line-height: 2; text-align: center; width: 70px">
            {{ $t("edit.angle.vviewMax") }}
          </div>
        </div>
      </div>

      <div style="margin: 20px 0 10px 0">{{ $t("edit.angle.hview") }}</div>
      <a-slider :max="hviewMax" :min="hviewMin" range :value="[
        this.currentAngle.viewrange.hview.min,
        this.currentAngle.viewrange.hview.max,
      ]" @change="handleChangeHviewSlide" />
      <div style="display: flex; justify-content: space-between">
        <div>
          <a-input-number v-model="currentAngle.viewrange.hview.min" :max="hviewMax" :min="hviewMin" :step="1"
            style="width: 70px" />
          <div style="line-height: 2; text-align: center; width: 70px">
            {{ $t("edit.angle.hviewLeft") }}
          </div>
        </div>
        <div>
          <a-input-number v-model="currentAngle.viewrange.hview.max" :max="hviewMax" :min="hviewMin" :step="1"
            style="width: 70px" />
          <div style="line-height: 2; text-align: center; width: 70px">
            {{ $t("edit.angle.hviewRight") }}
          </div>
        </div>
      </div>
      <div style="margin: 20px 0">
        <a-button block type="primary" ghost @click="resetData">
          {{$t("edit.angle.reset")}}
        </a-button>
      </div>
      <a-divider :style="{backgroundColor: '#505050'}" />
      <div style="margin: 0 0 10px 0">{{ $t("edit.angle.toScene") }}</div>
      <a-button block type="primary" ghost @click="showAllScenes">
        {{$t("edit.editMessage.sceneConfirm")}}
      </a-button>

      <div style="margin: 20px 0 0">
        <div class="list-container">
          <ImgItem :itemObj="item" v-for="(item, index) in sceneList" :key="index"></ImgItem>
        </div>
      </div>
    </div>

    <div class="view-btns">
      <a-button type="primary" @click="onClickSave">{{
        $t("actionTitles.save")
      }}
      </a-button>
      <!-- <a-button>取消</a-button> -->
    </div>
    <!--add group modal-->
    <a-modal v-model="modalVisible" :style="{ maxHeight: '800px' }" :title="$t('edit.editMessage.sceneConfirm')"
      :width="800" :destroyOnClose="true" @ok="handleConfirm" @cancel="handleCancel">
      <div class="select-body">
        <div class="item-padding" v-for="(value, k) in this.vrbase.scenes" :key="k" @click="selectScene(value)">
          <ImgItem :itemObj="value" :selected="selectedScene"></ImgItem>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import ImgItem from "../hotpoint/ImgItem.vue";
import { mapGetters } from "vuex";

const defaultAngle = {
  initview: { hlookat: 123, vlookat: 34 },
  fovrange: { min: 0, max: 140, default: 120 },
  viewrange: {
    hview: { min: -180, max: 180 },
    vview: { min: -180, max: 180 },
  },
};

export default {
  components: { ImgItem },
  data() {
    return {
      initview: "",
      sceneList: [],

      fovrangeMin: 0,
      fovrangeMax: 140,
      hviewMin: -180,
      hviewMax: 180,
      vviewMin: -90,
      vviewMax: 90,
      currentAngle: defaultAngle,
      modalVisible: false,
      selectedScene: [],
    };
  },
  computed: {
    ...mapGetters(["vrbase", "currentScenesId", "userInfo"]),
  },
  created() {
    console.log(
      "觸發created",
      '\nthis.currentScenesId:',this.currentScenesId,
      '\nthis.vrbase:',this.vrbase,
      '\nthis.vrbase.scenes[this.currentScenesId].angle:',this.vrbase.scenes[this.currentScenesId].angle
    );
  },
  watch: {
    currentScenesId: {
      handler: function handler(value) {
        this.currentAngle = JSON.parse(JSON.stringify(this.vrbase.scenes[value].angle))
      },
      immediate: true,
    },
    currentAngle: {
      handler: function (value) {
        console.log('觸發currentAngle:', value)
        setSceneAngle(value);
      },
      immediate: true,
      deep: true,
    },
    vrbase: {
      handler: function handler(value) {
        this.currentAngle = JSON.parse(JSON.stringify(value.scenes[this.currentScenesId].angle))
      },
      immediate: true,
      deep: true,
    }
  },
  methods: {
    resetData() {
      this.currentAngle = this.$deepClone(defaultAngle);
    },
    //判斷當前視角是否在垂直和水平視角內
    judgeView() {
      const hMax = this.currentAngle.viewrange.hview.max
      const hMin = this.currentAngle.viewrange.hview.min
      const vMax = this.currentAngle.viewrange.vview.max
      const vMin = this.currentAngle.viewrange.vview.min
      const hlookat = this.currentAngle.initview.hlookat
      const vlookat = this.currentAngle.initview.vlookat
      console.log('數據', hMax, hMin, vMax, vMin, hlookat, vlookat)
      // return
      const h = hlookat <= hMax && hlookat >= hMin ? true : false
      const v = vlookat <= vMax && vlookat >= vMin ? true : false
      // console.log('是否在',h,v)
      /*if(h && v){
        this.currentAngle.initview = getSceneViewAt();
      }*/
      if (!h) {
        //this.currentAngle.initview.hlookat = (hMax + hMin) / 2
      }
      if (!v) {
        //this.currentAngle.initview.vlookat = (vMax + vMin) / 2
      }
      // console.log('判斷方法裡面的initview==============',this.currentAngle.initview)

      console.log('judgeView後', this.currentAngle)
    },
    onClickSave() {
      console.log('judgeView前', this.currentAngle)
      this.judgeView()
      // this.currentAngle.initview = getSceneViewAt();
      this.vrbase.scenes[this.currentScenesId].angle = this.currentAngle;
      let selectedSceneIds = this.sceneList.map((s) => {
        return s.scene_id;
      });
      selectedSceneIds.forEach((sceneId) => {
        this.vrbase.scenes[sceneId].angle = this.$deepClone(this.currentAngle);
      });
      this.$store.dispatch("setVRBase", this.vrbase);
      this.$store.dispatch("saveVRBase", {
        vrbase: this.vrbase,
        showLoading: true,
      });
    },
    handleChangeFovrangeSlide(value) {
      this.currentAngle.fovrange.min = value[0];
      this.currentAngle.fovrange.max = value[1];
    },
    handleChangeVviewSlide(value) {
      this.currentAngle.viewrange.vview.min = value[0];
      this.currentAngle.viewrange.vview.max = value[1];
    },
    handleChangeHviewSlide(value) {
      this.currentAngle.viewrange.hview.min = value[0];
      this.currentAngle.viewrange.hview.max = value[1];
    },
    showAllScenes() {
      this.modalVisible = true;
    },
    handleConfirm() {
      this.modalVisible = false;
      this.sceneList = this.selectedScene;
    },
    handleCancel() {
      this.selectedScene = [];
    },
    selectScene(item) {
      // 沒有加，有則移除
      for (var i = 0; i < this.selectedScene.length; i++) {
        if (this.selectedScene[i].scene_id === item.scene_id) {
          this.selectedScene.splice(i, 1);
          return;
        }
      }
    }
  }
} 
</script>

<style lang="less" scoped>
.view-box {
  height: 100%;

  .view-content {
    height: calc(100% - 72px);
    padding: 20px 20px 0 20px;
    overflow-y: auto;

    .resetBtn {
      border-color: #7101ad;
      color: #ffffff;
    }
  }

  .view-btns {
    display: flex;
    justify-content: space-between;
    padding: 20px;

    .saveBtn {
      border-color: #7101ad;
      background-color: #7101ad;
    }
  }
}

.list-container {
  // display: flex;
  // flex-wrap: wrap;
  // justify-content: space-between;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  justify-items: center;
  grid-gap: 5px;
}

.select-body {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.item-padding {
  padding: 10px;
}
</style>